import { DISCOVERY_URL } from "../../utils/urls.ts";
import { brandEmail } from "../../utils/brand.ts";

class DammiFooter extends HTMLElement {
  connectedCallback() {
    const variant = this.getAttribute("variant") || "simple";
    const infoEmail = brandEmail("info");

    if (variant === "simple") {
      this.innerHTML = `
        <footer class="bg-white py-8 border-t border-slate-100">
          <div class="container mx-auto px-6 text-center text-slate-500 text-sm">
            <p>&copy; 2026 DAMMI.LV</p>
            <p class="mt-1">KOLOMBO SIA | Reg. Nr. 40203077142</p>
            <p class="mt-2 flex justify-center gap-4">
              <a href="privacy-policy.html" class="hover:text-slate-700 transition-colors underline underline-offset-2">
                <span data-en="Privacy Policy" data-lv="Privātuma politika" data-it="Informativa sulla Privacy">Privacy Policy</span>
              </a>
              <a href="terms-of-service.html" class="hover:text-slate-700 transition-colors underline underline-offset-2">
                <span data-en="Terms of Service" data-lv="Pakalpojumu noteikumi" data-it="Termini di Servizio">Terms of Service</span>
              </a>
            </p>
          </div>
        </footer>
      `;
    } else if (variant === "detailed") {
      this.innerHTML = `
        <footer class="bg-slate-900 text-white py-12">
          <div class="container mx-auto px-6">
            <div class="grid md:grid-cols-4 gap-8 mb-8">
              <div>
                <img src="assets/dammi-logo.svg" alt="DAMMI.LV" class="h-8 mb-4 brightness-0 invert">
                <p class="text-slate-400 text-sm">
                  <span data-en="Process Optimization Architects" data-lv="Procesu Optimizācijas Arhitekti" data-it="Architetti di Ottimizzazione Processi">Process Optimization Architects</span>
                </p>
              </div>
              <div>
                <h4 class="font-bold mb-4">
                  <span data-en="Quick Links" data-lv="Ātrās Saites" data-it="Link Rapidi">Quick Links</span>
                </h4>
                <ul class="space-y-2 text-slate-400">
                  <li><a href="index.html" class="hover:text-white transition-colors">
                    <span data-en="Home" data-lv="Sākums" data-it="Home">Home</span>
                  </a></li>
                  <li><a href="index.html#about" class="hover:text-white transition-colors">
                    <span data-en="About Us" data-lv="Par Mums" data-it="Chi Siamo">About Us</span>
                  </a></li>
                  <li><a href="checklist.html" class="hover:text-white transition-colors">
                    <span data-en="Self Assessment" data-lv="Pašnovērtējums" data-it="Autovalutazione">Self Assessment</span>
                  </a></li>
                  <li><a href="offers.html" class="hover:text-white transition-colors">
                    <span data-en="Offers" data-lv="Piedāvājumi" data-it="Offerte">Offers</span>
                  </a></li>
                  <li><a href="showcase.html" class="hover:text-white transition-colors">
                    <span data-en="Showcase" data-lv="Demonstrējums" data-it="Showcase">Showcase</span>
                  </a></li>
                </ul>
              </div>
              <div>
                <h4 class="font-bold mb-4">
                  <span data-en="Services" data-lv="Pakalpojumi" data-it="Servizi">Services</span>
                </h4>
                <ul class="space-y-2 text-slate-400">
                  <li><span data-en="Process Diagnosis" data-lv="Procesu Diagnoze" data-it="Diagnosi dei Processi">Process Diagnosis</span></li>
                  <li><span data-en="Process Prognosis" data-lv="Procesu Prognoze" data-it="Prognosi dei Processi">Process Prognosis</span></li>
                  <li><span data-en="Process Treatment" data-lv="Procesu Ārstēšana" data-it="Trattamento dei Processi">Process Treatment</span></li>
                </ul>
              </div>
              <div>
                <h4 class="font-bold mb-4">
                  <span data-en="Contact" data-lv="Kontakti" data-it="Contatti">Contact</span>
                </h4>
                <ul class="space-y-2 text-slate-400">
                  <li>
                    <a href="mailto:${infoEmail}" class="hover:text-white transition-colors">${infoEmail}</a>
                  </li>
                  <li>
                    <a href="${DISCOVERY_URL}" target="_blank" rel="noopener noreferrer" class="hover:text-white transition-colors">
                      <span data-en="Book a Meeting" data-lv="Rezervēt Tikšanos" data-it="Prenota un Incontro">Book a Meeting</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="border-t border-slate-800 pt-8 text-center text-slate-400 text-sm">
              <p>&copy; 2026 DAMMI.LV. <span data-en="All rights reserved." data-lv="Visas tiesības aizsargātas." data-it="Tutti i diritti riservati.">All rights reserved.</span></p>
              <p class="mt-1">KOLOMBO SIA | Reg. Nr. 40203077142</p>
              <p class="mt-3 flex justify-center gap-6">
                <a href="privacy-policy.html" class="hover:text-white transition-colors underline underline-offset-2">
                  <span data-en="Privacy Policy" data-lv="Privātuma politika" data-it="Informativa sulla Privacy">Privacy Policy</span>
                </a>
                <a href="terms-of-service.html" class="hover:text-white transition-colors underline underline-offset-2">
                  <span data-en="Terms of Service" data-lv="Pakalpojumu noteikumi" data-it="Termini di Servizio">Terms of Service</span>
                </a>
              </p>
            </div>
          </div>
        </footer>
      `;
    }
  }
}

customElements.define("dammi-footer", DammiFooter);
